import {APIClient, getLang, ProjectJSONClient} from "modules/utils";
import {PROJECT_API_PATH} from "modules";
import {
	fetchGamesJSONSuccess,
	fetchPlayersJSONSuccess,
	fetchChecksumsJSONSuccess,
} from "apps/BUDWEISERPOTM/modules/actions";
import {IApiResponse} from "modules/types";
import {
	addVoteActionSuccess,
	addVotesActionSuccess,
} from "apps/BUDWEISERPOTM/modules/actions/votes";

export const ContentPredictorApi = {
	JSON: {
		games: () =>
			ProjectJSONClient.get<ReturnType<typeof fetchGamesJSONSuccess>["payload"]>(
				"games.json"
			),
		players: () =>
			ProjectJSONClient.get<ReturnType<typeof fetchPlayersJSONSuccess>["payload"]>(
				"players.json"
			),
		checksums: () =>
			ProjectJSONClient.get<ReturnType<typeof fetchChecksumsJSONSuccess>["payload"]>(
				"checksums.json"
			),
	},
	Votes: {
		postVotes: (params: {gameId: number; playerId: number}) =>
			APIClient.post<IApiResponse<ReturnType<typeof addVoteActionSuccess>["payload"]>>(
				`${getLang()}/${PROJECT_API_PATH}votes`,
				params
			),
		getVotes: () =>
			APIClient.get<IApiResponse<ReturnType<typeof addVotesActionSuccess>["payload"]>>(
				`${getLang()}/${PROJECT_API_PATH}votes`
			),
		patchVotes: ({playerId, voteId}: {voteId: number; playerId: number}) =>
			APIClient.post<IApiResponse<ReturnType<typeof addVoteActionSuccess>["payload"]>>(
				`${getLang()}/${PROJECT_API_PATH}votes-update/${voteId}`,
				{playerId}
			),
	},
};

export default ContentPredictorApi;
